// extracted by mini-css-extract-plugin
module.exports = {"root":"_3Mq7l","link":"_1g0zI","img":"_1O8Ga"};